<template>
  <p class="text-xs leading-[22px] tracking-[0px] text-black1 md:text-[13px] md:leading-[24px] md:tracking-[1px]">
    <slot />
  </p>
</template>
